import {dataTestId} from '@hconnect/uikit'
import {Typography, Skeleton, Stack} from '@mui/material'
import moment from 'moment-timezone'
import {FC} from 'react'

import {ReactComponent as SiloIcon} from '../../../../../../assets/icons/SilosIcon.svg'
import {PlannerIcon} from '../../../../../../shared/components/PlannerIcon'
import {useHistoryStoragesByIdQuery} from '../../../../../../shared/hooks/api'
import {SelectedSilos} from '../../../../../../shared/interfaces/api'
import {usePlanningChartStartEnd} from '../../../PlanningChartStartEndProvider'

import {SelectedSilo} from './SelectedSilo'

interface SelectedSilosRow {
  selectedSilos: SelectedSilos
  scheduleItemEnd: string
}

export const SelectedSilosRow: FC<SelectedSilosRow> = ({selectedSilos, scheduleItemEnd}) => {
  const {startOfPlan, endOfPlan} = usePlanningChartStartEnd()
  const scheduleItemEndUTC = moment.utc(scheduleItemEnd)
  const {data: storagesById} = useHistoryStoragesByIdQuery({
    timeFrame: [startOfPlan, endOfPlan],
    date: scheduleItemEndUTC
  })
  return (
    <Stack direction="row" spacing={0} alignItems="center" {...dataTestId('selected_silos_row')}>
      <PlannerIcon icon={<SiloIcon />} sx={{pl: 0}} />
      <Stack direction="row" alignItems="center" flexWrap="wrap" gap={2}>
        {storagesById ? (
          <SelectedSilo selectedSilos={selectedSilos} storagesById={storagesById} />
        ) : (
          <Typography variant="body1">
            <Skeleton sx={{width: ({spacing}) => spacing(5)}} />
          </Typography>
        )}
      </Stack>
    </Stack>
  )
}
